import { LinkHighlightButton } from '../HighlightButton/HighlightButton';

const resume = () => (
  <main className="mainContainer centeredVertically">
    <div style={{ textAlign: 'center' }}>
      <a style={{ color: 'var(--highlight)' }} href="/static/lawrence_luo_resume.pdf" target="_blank" rel="noopener noreferrer" download>Download Resume (PDF)</a>
    </div>
  </main>
)

export default resume;
